import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import TadobaContext from "../Components/Context/TadobaContext";
import { useContext } from "react";
import { Radio, ConfigProvider } from "antd";
import MapTable from "../Components/Map/MapTable";
import { makeRequest } from "../api";
import HeatMapContainer from "../Components/Map/HeatMap/HeatMapContainer";
import HeatMapFilters from "../Components/Map/HeatMap/HeatMapFilters";
import HerbivoreMap from "../Components/Map/HerbivoreMap/HerbivoreMap";
import HerbivoreOptions from "../Components/Map/HerbivoreMap/HerbivoreOptions";

const Mapview = ({
  tigerslist,
  camera,
  setCamera,
  CustomDate,
  markers,
  setMarkers,
  duration,
  setDuration,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isYearlyTigerChecked,
  setIsYearlyTigerChecked,
  selectedSpecies,
  setSelectedSpecies,
  selectedTiger,
  setSelectedTigers,
  selectedCamera,
  setSelectedCamera,
  id,
  setId,
  mapRef,
  setMapRef,
  selectedYear,
  isTigerNetworkChecked,
  setIsTigerNetworkChecked,
  setButtonClicked,
}) => {
  const api = useContext(TadobaContext);
  const [species, setSpecies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState(null);
  const [isTiger, setIsTiger] = useState(false);
  const [selectedMapOption, setSelectedMapOption] = useState("Normal");
  const [herbivoreData, setHerbivoreData] = useState([]);
  const [herbivoreLoading, setHerbivoreLoading] = useState([]);

  const [list, setList] = useState([
    "Tiger",
    "Leopard",
    "Sambar",
    "Dhole",
    "Chital",
    "Langur",
    "Peafowl",
    "Wild boar",
    "Gaur",
    "Cattle grazing",
    "Hare",
    "Nilgai",
    "Dhole",
    "Porcupine",
    "Rhesus macaque",
    "Human Disturbance",
    "Chousingha",
    "Stray dog",
    "Bird",
    "Golden jackal",
    "Small indian civet",
    "Asian palm civet",
    "Sloth bear",
    "Jungle cat",
    "Honey badger",
    "Crocodile",
    "Grey mongoose",
    "Animal association",
    "Ruddy mongoose",
    "Domestic cat",
    "Rusty spotted cat",
    "Unid",
    "Blank",
    "Chinkara",
    "Barking deer",
    "Indian pangolin",
    "Spotted deer",
    "Indian gaur",
    "Blue bull",
    "Four horned antelope",
    "Indian gazelle",
    "Wild dog",
    "Common palm civet",
    "Indian porcupine",
    "Cattle",
    "Asian_palm_civet",
    "wolf",
  ]);

  const options = [
    { label: "All Species Distribution", value: "Normal" },
    { label: "Herbivore Distribution", value: "Herbivore" },
  ];

  const handleMarkerDragEnd = (e) => {};

  useEffect(() => {
    getHerbivoreData();
  }, [selectedYear]);

  useEffect(() => {
    if (selectedSpecies !== null && species && selectedTiger === null) {
      localStorage.setItem("selectedSpecies", JSON.stringify(selectedSpecies));
      setLoading(true);
      const item = species.filter((value) => {
        return value.value === selectedSpecies;
      });
      getZone(item[0]?.key);
      if (item[0]?.label === "Tiger") {
        setIsTiger(true);
      } else {
        setIsTiger(false);
      }
    } else if (selectedTiger !== null && species) {
      setIsTiger(true);
      localStorage.setItem("selectedTiger", JSON.stringify(selectedTiger));
      setLoading(true);
      const item = species.filter((value) => {
        return value.value === 0;
      });
      getZone(item[0]?.key, selectedTiger);
    }
  }, [species, selectedYear]);

  const cameraChangeHandler = (value) => {
    if (value.length === 0) {
      setMarkers(
        camera.map((val, key) => {
          return {
            label: val.label,
            lat: val.lat,
            lng: val.lng,
            count: val.count,
            dates: val.dates,
          };
        })
      );
    } else {
      setMarkers(
        camera
          .filter((item) => value.includes(item.value))
          .map((val, key) => {
            return {
              label: val.label,
              lat: val.lat,
              lng: val.lng,
              count: val.count,
              dates: val.dates,
            };
          })
      );
    }
    localStorage.setItem("selectedCamera", JSON.stringify(value));
    setSelectedCamera(value);
  };

  useEffect(() => {
    if (id) {
      localStorage.setItem("id", JSON.stringify(id));
    }
  }, [id]);

  const getZone = async (item = null, tigerId = null) => {
    setId(item);
    let data = {
      species_id: item,
      start_date: startDate,
      end_date: endDate,
      fixed_duration: duration,
      tigers_id: tigerId,
      ...(selectedYear ? { years: [+selectedYear] } : {}),
    };

    if (duration === "custom" && CustomDate !== null) {
      data = {
        ...data,
        start_date: format(new Date(CustomDate[0]), "yyyy-MM-dd"),
        end_date: format(new Date(CustomDate[1]), "yyyy-MM-dd"),
        duration: "",
      };
      setStartDate(format(new Date(CustomDate[0]), "yyyy-MM-dd"));
      setEndDate(format(new Date(CustomDate[1]), "yyyy-MM-dd"));
    }

    let token = "";
    let csrf = "";
    try {
      if (item !== null) {
        if (localStorage.token) {
          token = localStorage.token;
        }
        if (localStorage.csrf) {
          csrf = localStorage.csrf;
        }
        const result = await makeRequest(
          "post",
          `api/v1/map/camera_by_species/`,
          data
        );

        setCamera(
          result.data.data.map((value, key) => {
            return {
              label: value.station_name,
              value: key,
              id: value.station_id,
              lat: value.latitude,
              lng: value.longitude,
              count: value.count,
              dates: value.dates,
            };
          })
        );

        setMarkers(
          result.data.data.map((value, key) => {
            return {
              lat: value.latitude,
              label: value.station_name,
              lng: value.longitude,
              count: value.count,
              dates: value.dates,
            };
          })
        );
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCamera.length > 0 && camera) {
      cameraChangeHandler(selectedCamera);
    }
  }, [camera]);

  useEffect(() => {
    if (selectedSpecies) {
      const item = species.filter((value) => {
        return value.value === selectedSpecies;
      });
      if (item.length > 0) {
        getZone(item[0].key);
      }
    }
  }, [duration]);

  useEffect(() => {
    if (selectedSpecies !== null || selectedSpecies !== undefined) {
      const item = species.filter((value) => {
        return value.value === selectedSpecies;
      });
      if (item.length > 0) {
        getZone(item[0].key, selectedTiger);
      }
    }
    // getZone();
  }, [startDate, endDate]);

  const speciesChangeHandler = (event) => {
    setSelectedSpecies(event);
    localStorage.setItem("selectedSpecies", JSON.stringify(event));
    setLoading(true);
    setSelectedCamera([]);
    setSelectedTigers(null);
    setCamera([]);
    const item = species.filter((value) => {
      return value.value === event;
    });
    getZone(item[0].key);
    if (item[0].label === "Tiger") {
      setIsTiger(true);
    } else {
      setIsTiger(false);
    }
  };

  useEffect(() => {
    if (api.allSpecies !== null) {
      setSpecies(
        api.allSpecies
          .filter((value) => list.includes(value.name))
          .sort((a, b) => list.indexOf(a.name) - list.indexOf(b.name))
          .map((value, key) => {
            return {
              label: value.name,
              value: key,
              key: value.id,
            };
          })
      );
    } else {
      setSpecies(null);
    }
  }, [api.allSpecies]);

  const tigerSelectionHandler = (event) => {
    setSelectedTigers(event);
    localStorage.setItem("selectedTiger", JSON.stringify(event));
    setLoading(true);
    const item = species.filter((value) => {
      return value.value === 0;
    });
    getZone(item[0].key, event);
    if (!event) {
      setIsTigerNetworkChecked(false);
      setIsYearlyTigerChecked(false);
    }
  };

  const detailTigerView = () => {
    setButtonClicked(true);
  };

  const handleYearlyTigerRadioChange = () => {
    setIsYearlyTigerChecked(!isYearlyTigerChecked);
    setStartDate("");
    setEndDate("");
    setDuration("");
    setLoading(true);
    const item = species.filter((value) => {
      return value.value === 0;
    });
    getZone(item[0].key, selectedTiger);
    setIsTigerNetworkChecked(false);
  };

  const handleTigerNetworkRadioChange = () => {
    setIsTigerNetworkChecked(!isTigerNetworkChecked);
    setIsYearlyTigerChecked(false);
  };

  const getHerbivoreData = async () => {
    let token = "";
    let csrf = "";
    setHerbivoreLoading(true);
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      console.log(selectedYear);
      let url = "/api/v1/identification/herbs_per_camera/";
      if (
        selectedYear !== undefined &&
        selectedYear !== null &&
        selectedYear !== ""
      ) {
        url += `?year=${selectedYear}`;
      }

      const result = await makeRequest("get", url);
      const topHerbivoreData = [...result.data.data]
        .sort((a, b) => b.herb_count - a.herb_count)
        .slice(0, 50);
      setHerbivoreData(topHerbivoreData);
      setHerbivoreLoading(false);
    } catch (error) {
      setHerbivoreLoading([]);
      setLoading(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Radio: {
            buttonSolidCheckedBg: "#E8DFD5",
            buttonSolidCheckedActiveBg: "#E8DFD5",
            buttonSolidCheckedHoverBg: "#E8DFD5",
            colorPrimary: "#E67817",
            colorPrimaryHover: "#FFF3E8",
            colorPrimaryBorder: "#FFF3E8",
          },
          DatePicker: {
            activeBorderColor: "#FFF3E8",
            colorLinkActive: "#FFF3E8",
            colorPrimary: "#FFF3E8",
            hoverBorderColor: "#FFF3E8",
            colorPrimaryBorder: "#FFF3E8",
          },
          Select: {
            optionActiveBg: "#FFF3E8",
            optionSelectedBg: "#FFF3E8",
            optionFontSize: 14,
            colorPrimaryHover: "#E67817",
            controlOutline: "#FFF3E8",
            multipleItemBg: "#FFF3E8",
          },
        },
      }}
    >
      <div className="">
        <div style={{ paddingBottom: "0px" }} className="Card MapCard">
          {selectedMapOption === "Normal" ? (
            <HeatMapContainer
              api={api}
              position={position}
              setPosition={setPosition}
              mapRef={mapRef}
              setMapRef={setMapRef}
              isTigerNetworkChecked={isTigerNetworkChecked}
              markers={markers}
              isYearlyTigerChecked={isYearlyTigerChecked}
              handleMarkerDragEnd={handleMarkerDragEnd}
              handleYearlyTigerRadioChange={handleYearlyTigerRadioChange}
              handleTigerNetworkRadioChange={handleTigerNetworkRadioChange}
            />
          ) : (
            <HerbivoreMap
              data={herbivoreData}
              setData={setHerbivoreData}
              loading={herbivoreLoading}
              seLoading={setHerbivoreLoading}
              api={api}
              selectedYear={selectedYear}
            />
          )}
          <div className="Map-Right">
            <div className="Map-View-Description" onClick={handleMarkerDragEnd}>
              <span>View the area covered by various species</span>
            </div>
            <div style={{ marginTop: "2vh" }}>
              <Radio.Group
                options={options}
                value={selectedMapOption}
                onChange={(e) => setSelectedMapOption(e.target.value)}
              />{" "}
            </div>
            {selectedMapOption === "Normal" ? (
              <HeatMapFilters
                species={species}
                selectedSpecies={selectedSpecies}
                loading={loading}
                speciesChangeHandler={speciesChangeHandler}
                camera={camera}
                selectedCamera={selectedCamera}
                cameraChangeHandler={cameraChangeHandler}
                isTiger={isTiger}
                selectedTiger={selectedTiger}
                tigerSelectionHandler={tigerSelectionHandler}
                tigerslist={tigerslist}
                detailTigerView={detailTigerView}
                isYearlyTigerChecked={isYearlyTigerChecked}
                handleYearlyTigerRadioChange={handleYearlyTigerRadioChange}
                isTigerNetworkChecked={isTigerNetworkChecked}
                handleTigerNetworkRadioChange={handleTigerNetworkRadioChange}
              />
            ) : (
              <HerbivoreOptions
                data={herbivoreData}
                setData={setHerbivoreData}
                herbivoreLoading={loading}
              />
            )}
          </div>
        </div>
        {selectedMapOption === "Normal" && (
          <div style={{ marginTop: "2vh" }} className="SpeciesTable">
            <MapTable
              camera={camera}
              selectedCamera={selectedCamera}
              speciesID={id}
              geolocationBeat={[]}
              tiger_types={selectedTiger}
              start_date={startDate}
              end_date={endDate}
              selectedYear={selectedYear}
            />
          </div>
        )}
      </div>
    </ConfigProvider>
  );
};

export default Mapview;
